(function () {

    'use strict';

    const {BehaviorSubject} = require("rxjs");

    const LINE_STATUS = {
        'rdvLate': {
            'color': '#F4511E',
            'icon': 'mdi-clock-alert',
        },
        'rdvMissed': {
            'color': '#D50000',
            'icon': 'mdi-call-missed',
        },
        'rdvWaiting': {
            'color': '#00E676',
            'icon': 'mdi-calendar-clock',
        },
        'entryWR': {
            'color': '#0097A7',
            'icon': 'mdi-seat-legroom-extra',
        },
        'entryMissed': {
            'color': '#D50000',
            'icon': 'mdi-account-clock',
        },
        'entrySV': {
            'color': '#8E24AA',
            'icon': 'mdi-hospital',
        },
        'entryEV': {
            'color': '#3F51B5',
            'icon': 'mdi-clock-end',
        },
        'entryClosedAtMidnight': {
            'color': '#FFAB00',
            'icon': 'mdi-exit-to-app',
        },
        'entryEX': {
            'color': '#78909C',
            'icon': 'mdi-exit-run',
        },
    };

    class WorkFlowService {
        constructor($q, $http, $mdDialog, mnWebSocket, moment, $translate, system, $sce) {
            this.q = $q;
            this.$sce = $sce;
            this.http = $http;
            this.dialog = $mdDialog;
            this.moment = moment;
            this.ws = mnWebSocket;
            this.translate = $translate;

            this.dateFormat = system['date_format'].js;
            this.timeFormat = system['time_format'].js;
            this.dateTimeFormat = system['date_format'].naive;

            this.filterSubject = new BehaviorSubject([
                {id: 'RDV', label: 'daily_workflow.filter_rdv'},
                {id: 'WR', label: 'daily_workflow.filter_wr'},
                {id: 'SV', label: 'daily_workflow.filter_sv'},
                {id: 'EV', label: 'daily_workflow.filter_ev'},
                {id: 'EX', label: 'daily_workflow.filter_ex'},
            ]);

            this.columnConfiguration = [
                {
                    key: "rdv_start_time",
                    label: "daily_workflow.rdv_start_time",
                    classes: "text-center",
                    getContent: item => {
                        return `<span>${item['start_time'] ? item['start_time'] : ''}</span>`;
                    }
                },
                {
                    key: "patient_name",
                    label: "daily_workflow.patient_name",
                    classes: 'workflow-patient-name',
                    getContent: item => {
                        let html = `<span style=${item['patient_is_draft'] ? "color:#e53935;" : ""} class="flex">${item['patient_full_name']}</span>`;

                        if (item['has_group_appointment'] || item['event_type'] === "group-rdv") {
                            html += `<md-icon class="mdi mdi-account-group md-icon-green-300"></md-icon>`;
                        }

                        if (!item['patient_has_visit']) {
                            html += `<md-icon class="mdi mdi-checkbox-blank-circle md-icon-red-600"></md-icon>`;
                        }

                        if (item['is_urgent']) {
                            html += `<md-icon class="mdi mdi-ambulance md-icon-red-600"></md-icon>`;
                        }

                        html += `<mn-patient-alert icon-button patient="${item.patient_id}" class="workflow-icon-button"></mn-patient-alert>`;

                        return html;
                    }
                },
                {
                    key: "patient_age",
                    label: "daily_workflow.patient_age",
                    getContent: item => {
                        return `<span>${item['patient_age'] ? item['patient_age'] : ''}</span>`;
                    }
                },
                {
                    key: "patient_gender",
                    label: "daily_workflow.patient_gender",
                    classes: "text-center",
                    getContent: item => {
                        let icon = "";
                        switch (item.patient_gender) {
                            case 'MALE':
                                icon = 'mdi-human-male';
                                break;
                            case 'FEMALE':
                                icon = 'mdi-human-female';
                                break;
                        }

                        return `<md-icon aria-label="gender" class="mdi ${icon} ${item.patient_gender} workflow-gender-icon"></md-icon>`;
                    }
                },
                {
                    key: "patient_insurance",
                    label: "daily_workflow.patient_insurance",
                    getContent: item => {
                        return `<span>${item['patient_default_insurance'] ? item['patient_default_insurance'] : ''}</span>`;
                    }
                },
                {
                    key: "status",
                    label: "daily_workflow.status",
                    classes: "text-center",
                    getContent: item => {
                        return `
                            <md-icon class="mdi ${item['status']['icon']}" style="color: ${item['status']['color']}">
                            <md-tooltip md-direction="bottom" md-delay="150">
                                <span>${item['status']['label']}</span>
                            </md-tooltip>
                        `;
                    }
                },
                {
                    key: "reason",
                    label: "daily_workflow.reason",
                    classes: "text-center",
                    getContent: item => {
                        if (!item['reason']) return "<span></span>";

                        return `<span style="background: ${item['reason']['color']}" class="mn-badge">${item['reason']['value']}</span>`;
                    }
                },
                {
                    key: "agenda",
                    label: "daily_workflow.agenda",
                    classes: "text-center",
                    getContent: item => {
                        if (!item['agenda']) return "<span></span>";

                        return `<span style="background: ${item['agenda']['color']}" class="mn-badge">${item['agenda']['name']}</span>`;
                    }
                },
                {
                    key: "entry_time",
                    label: "daily_workflow.entry_time",
                    getContent: item => {
                        if (!item['entry_time']) return "<span></span>";

                        return `<span>${this.moment(item['entry_time'], this.dateTimeFormat).format('HH:mm')}</span>`
                    }
                },
                {
                    key: "waiting_time",
                    label: "daily_workflow.waiting_time",
                    getContent: item => {
                        if (!item['status'] || !item['status']['waitingTime']) return "<span></span>";

                        return `<span>${item['status']['waitingTime']}</span>`;
                    }
                },
                {
                    key: "visit_time",
                    label: "daily_workflow.visit_time",
                    getContent: item => {
                        if (!item['status'] || !item['status']['visitTime']) return "<span></span>";

                        return `<span>${item['status']['visitTime']}</span>`;
                    }
                },
                {
                    key: "physician",
                    label: "daily_workflow.physician",
                    getContent: item => {
                        if (!item['physician_full_name']) return "<span></span>";

                        return `<span>${item['physician_full_name']}</span>`;
                    }
                },
                {
                    key: "patient_next_appointment",
                    label: "daily_workflow.next_appointment",
                    getContent: item => {
                        if (!item['patient_next_appointment']) return "<span></span>";

                        return `<span>${item['patient_next_appointment']}</span>`;
                    }
                },
                {
                    key: "comment",
                    label: "daily_workflow.comment",
                    getContent: item => {
                        if (!item['comment']) return "<span></span>";

                        return `<span>${item['comment']}</span>`;
                    }
                }
            ];
        }

        static get $inject() {
            return ["$q", "$http", "$mdDialog", "mnWebSocket", "moment", "$translate", "system", "$sce"];
        }

        getWorkFlow(date) {
            const deferred = this.q.defer();
            const query = {
                date: this.moment(date).format('YYYY-MM-DD')
            };

            this.ws.call('frontdesk.WorkFlow.get_daily_workflow', query).then(data => {
                const items = this.handleData(data);
                deferred.resolve(items);
            }, deferred.reject);

            return deferred.promise;
        }


        handleData(data) {
            return _.chain([])
                .concat(
                    this.handleEntriesWithAppointments(data),
                    this.handleAppointmentsWithoutEntries(data),
                    this.handleGroupAppointments(data),
                    this.handleEntriesWithoutAppointments(data),
                )
                .orderBy([
                    item => item['is_urgent'] ? 1 : 0,
                    item => this.moment(item.start ? item.start : item.entry_time).valueOf()
                ], ["desc", "asc"])
                .value()
        }

        handleEntriesWithAppointments(data) {
            let entries = _.filter(data.entries, 'has_appointment');
            let appointments = _.filter(data.appointments, 'is_entered');

            return _.map(entries, item => {
                let appointment = _.find(appointments, ['id', item['appointment_id']]);
                return _.assign({}, appointment, item, {
                    comment: item.other_comment,
                    status: this.handleEntryStatus(item),
                    track_id: `entry-${item.id}-${item.patient_has_visit}-${item.is_urgent}`,
                });
            });
        }

        handleAppointmentsWithoutEntries(data) {
            return _.chain(data.appointments)
                .filter(['is_entered', false])
                .map(item => {
                    return _.assign({}, item, {
                        stat: 'RDV',
                        exit_time: null,
                        entry_time: null,
                        visit_end_time: null,
                        visit_start_time: null,
                        comment: item.other_comment,
                        track_id: `appointment-${item.id}`,
                        status: this.handleAppointmentStatus(item),
                    });
                })
                .value();
        }

        handleGroupAppointments(data) {
            return _.chain(data.group_appointments)
                .filter(['all_patients_entered', false])
                .map(item => {
                    return _.chain(item.patients)
                        .filter(patient => {
                            const patient_id = _.get(patient, "id")
                            if (!!patient_id) {
                                return item.patients_entered.includes(patient.id);
                            }

                            return false;
                        })
                        .map(patient => {
                            return _.chain(item)
                                .cloneDeep()
                                .omit(["patients"])
                                .assign({
                                    patient_id: patient.id,
                                    patient_full_name: patient.full_name,
                                    patient_has_visit: patient.has_visit,
                                    patient_age: patient.age,
                                    patient_gender: patient.gender,
                                    patient_is_draft: patient.is_draft,
                                    patient_last_visit_id: patient.last_visit_id,
                                    patient_default_insurance: patient.default_insurance,
                                    patient_next_appointment: patient.next_appointment,

                                    stat: 'RDV',
                                    exit_time: null,
                                    entry_time: null,
                                    visit_end_time: null,
                                    visit_start_time: null,
                                    comment: item.other_comment,
                                    track_id: `group-appointment-${item.id}-${patient.id}`,
                                    status: this.handleAppointmentStatus(item),
                                })
                                .value();
                        })
                        .value();
                })
                .flatten()
                .value();
        }

        handleEntriesWithoutAppointments(data) {
            return _.chain(data.entries)
                .filter(['has_appointment', false])
                .map(item => _.assign({}, item, {
                    comment: item.other_comment,
                    status: this.handleEntryStatus(item),
                    track_id: `entry-${item.id}-${item.patient_has_visit}-${item.is_urgent}`,
                }))
                .value();
        }

        orderData(items) {
            return _.orderBy(items, [
                item => item['is_urgent'] ? 1 : 0,
                item => this.moment(item.entry_time ? item.entry_time : item.start).valueOf()
            ], ["desc", "asc"]);
        }

        // items status
        handleAppointmentStatus(item) {
            const now = this.moment();
            const appointmentDate = this.moment(item.date, this.dateFormat);
            const appointmentDateTime = this.moment(item.start, this.dateTimeFormat);
            const duration = this.moment.duration(now.diff(appointmentDateTime)).humanize();

            if (appointmentDate.isSame(now, 'day')) {
                if (now.isSameOrAfter(appointmentDateTime, 'm')) return _.assign({}, LINE_STATUS['rdvLate'], {
                    label: this.translate.instant('daily_workflow.rdv_late', {duration}),
                });
                else return _.assign({}, LINE_STATUS['rdvWaiting'], {
                    label: this.translate.instant('daily_workflow.rdv_waiting', {duration})
                });
            } else if (appointmentDate.isBefore(now, 'day')) return _.assign({}, LINE_STATUS['rdvMissed'], {
                label: this.translate.instant('daily_workflow.rdv_missed')
            });
            else return _.assign({}, LINE_STATUS['rdvWaiting'], {
                    label: this.translate.instant('daily_workflow.rdv_waiting', {duration})
                })
        }

        handleEntryStatus(item) {
            const now = this.moment();
            const entryTime = this.moment(item['entry_time'], this.dateTimeFormat);
            const visitStartTime = this.moment(item['visit_start_time'], this.dateTimeFormat);
            const visitEndTime = this.moment(item['visit_end_time'], this.dateTimeFormat);
            const exitTime = this.moment(item['exit_time'], this.dateTimeFormat);

            const isPast = entryTime.isBefore(now, 'day');

            if (item.stat === 'WR') {
                if (isPast) {
                    return _.assign({}, LINE_STATUS['entryMissed'], {
                        label: this.translate.instant('daily_workflow.entry_missed')
                    })
                } else {
                    let duration = this.moment.duration(now.diff(entryTime)).humanize();

                    return _.assign({}, LINE_STATUS['entryWR'], {
                        waitingTime: _.capitalize(duration),
                        label: this.translate.instant('daily_workflow.entry_wr', {duration})
                    });
                }
            } else if (item.stat === 'SV') {
                let waitingTime = this.moment.duration(visitStartTime.diff(entryTime)).humanize();

                if (isPast) {
                    return _.assign({}, LINE_STATUS['entryClosedAtMidnight'], {
                        waitingTime: _.capitalize(waitingTime),
                        label: this.translate.instant('daily_workflow.entry_closed_at_midnight')
                    })
                } else {
                    let duration = this.moment.duration(now.diff(visitStartTime)).humanize();

                    return _.assign({}, LINE_STATUS['entrySV'], {
                        waitingTime: _.capitalize(waitingTime),
                        visitTime: _.capitalize(duration),
                        label: this.translate.instant('daily_workflow.entry_sv', {duration}),
                    })
                }
            } else if (item.stat === 'EV') {
                let waitingTime = this.moment.duration(visitStartTime.diff(entryTime)).humanize();
                let visitTime = this.moment.duration(visitEndTime.diff(visitStartTime)).humanize();

                if (isPast) {
                    return _.assign({}, LINE_STATUS['entryClosedAtMidnight'], {
                        waitingTime: _.capitalize(waitingTime),
                        visitTime: _.capitalize(visitTime),
                        label: this.translate.instant('daily_workflow.entry_closed_at_midnight')
                    });
                } else {
                    let duration = this.moment.duration(now.diff(visitEndTime)).humanize();
                    return _.assign({}, LINE_STATUS['entryEV'], {
                        waitingTime: _.capitalize(waitingTime),
                        visitTime: _.capitalize(visitTime),
                        label: this.translate.instant('daily_workflow.entry_ev', {duration}),
                    });
                }
            } else if (item.stat === 'EX') {
                let duration = this.moment.duration(now.diff(exitTime)).humanize();

                if (visitStartTime.isValid()) {
                    let waitingTime = this.moment.duration(visitStartTime.diff(entryTime)).humanize();
                    let visitTime = this.moment.duration(
                        visitEndTime.isValid() ? visitEndTime.diff(visitStartTime) : exitTime.diff(visitStartTime)
                    ).humanize();

                    let label = this.translate.instant(
                        `daily_workflow.entry_ex${isPast ? '_past' : ''}`,
                        {duration: isPast ? exitTime.format(this.timeFormat) : duration}
                    );

                    return _.assign({}, LINE_STATUS['entryEX'], {
                        label, waitingTime: _.capitalize(waitingTime), visitTime: _.capitalize(visitTime),
                    });
                } else {
                    let waitingTime = this.moment.duration(exitTime.diff(entryTime)).humanize();

                    return _.assign({}, LINE_STATUS['entryMissed'], {
                        waitingTime: _.capitalize(waitingTime),
                        label: this.translate.instant('daily_workflow.entry_missed')
                    });
                }
            }
        }

        getWorkflowViews() {
            const deferred = this.q.defer();
            const url = `/api/workflow-view/`;

            this.http.get(url)
                .then(success, deferred.reject);

            function success(response) {
                const items = _.orderBy(response.data, item => [item.is_system ? 0 : 1, _.lowerCase(item.name)], ['asc', 'asc']);
                deferred.resolve(items);
            }

            return deferred.promise;
        }

        removeWorkflowView(view, ev) {
            const deferred = this.q.defer();
            const confirm = this.dialog.confirm()
                .targetEvent(ev)
                .ariaLabel('remove plan confirm')
                .ok(this.translate.instant('confirm_ok'))
                .cancel(this.translate.instant('confirm_cancel'))
                .title(this.translate.instant('workflow_view_remove_confirm', view));

            this.dialog.show(confirm).then(() => {
                const url = `/api/workflow-view/${view.id}/`;
                this.http.delete(url).then(deferred.resolve, deferred.reject);
            }, deferred.reject);

            return deferred.promise;
        }

        saveWorkflowView(item) {
            const deferred = this.q.defer();
            const url = `/api/workflow-view/${_.isNil(item.id) ? '' : `${item.id}/`}`;

            this.http.post(url, item)
                .then(success, deferred.reject);

            function success(response) {
                deferred.resolve(response.data);
            }

            return deferred.promise;
        }

        getColumnConfiguration() {
            return _.cloneDeep(this.columnConfiguration);
        }
    }

    module.exports = WorkFlowService;

})();
